import { Alert, AlertColor } from '@mui/material'
import { useTranslate } from '@tolgee/react'

export type InspectContainerAlertType = 'onSystem' | 'onTerminal' | 'announced' | undefined

interface Props {
  alertType: InspectContainerAlertType
}

export const InspectContainerAlert = ({ alertType }: Props) => {
  const { t } = useTranslate()

  const containerAlertMessage = (() => {
    if (!alertType) return undefined

    let message
    let severity: AlertColor

    if (alertType === 'onTerminal') {
      message = t(
        'containerWithThisNumberIsAlreadyOnTerminal',
        'Container with this number is already on terminal.',
      )
      severity = 'error'
    } else if (alertType === 'announced') {
      message = t(
        'containerWithThisNumberIsAlreadyAnnounced',
        'Container with this number is already announced for this visit.',
      )
      severity = 'error'
    } else {
      message = t(
        'containerWithThisNumberExistsInTheSystem',
        'A container with this number already exists. Any changes you make will be overwritten.',
      )
      severity = 'info'
    }

    return { message, severity }
  })()

  if (!containerAlertMessage) return <></>

  return (
    <Alert severity={containerAlertMessage.severity} sx={{ mt: 2 }}>
      {containerAlertMessage.message}
    </Alert>
  )
}
